import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../../constants/react_app_consts";

const initialState = {
    retrieve_specific_delivery_note: { status: "idle" },
};

export const retrieve_specific_delivery_note_Slice = createSlice({
    name: "retrieve_specific_delivery_note",
    initialState,
    reducers: {
        success_retrieve_specific_delivery_note: (state, action) => {
            state.retrieve_specific_delivery_note = { status: app_consts.SUCCESS, data: action.payload };
        },
        fail_retrieve_specific_delivery_note: (state, action) => {
            state.retrieve_specific_delivery_note = { status: app_consts.FAIL, message: action.payload };
        },
        reset_retrieve_specific_delivery_note: (state) => {
            state.retrieve_specific_delivery_note = { status: app_consts.IDLE };
        },
        loading_retrieve_specific_delivery_note: (state) => {
            state.retrieve_specific_delivery_note = { status: app_consts.LOADING };
        },
    }
});

export const { success_retrieve_specific_delivery_note, fail_retrieve_specific_delivery_note, reset_retrieve_specific_delivery_note, loading_retrieve_specific_delivery_note } = retrieve_specific_delivery_note_Slice.actions;

export default retrieve_specific_delivery_note_Slice.reducer;